// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1ijtc","col":"styles_col__3tGp8"};